export const COMMISSIONS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.CommissionsUpdated";
export const SUBSIDIES_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.SubsidiesUpdated";
export const COMMISSION_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.CommissionComputed";
export const COMMISSIONS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.CommissionsInvalidated";
export const OFFER_SUBSIDIES_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferSubsidiesComputed";
